import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:4000/',
    baseURL: 'https://mvp.multipad.co/'
});

export default api;